// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { BarGroupedChart } from '@/components/composite/Charts/BarGroupedChart';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';

export const postHistoryConfig: ChartType<typeof BarGroupedChart> = {
    title: 'chart.instagram.post_history',
    tooltip: 'chart.instagram.post_history_tooltip',
    id: 'posts_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.instagram.post_history_name'
    },
    social: INSTAGRAM,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_FULL,
    type: 'chart',
    isXAxisDate: true,
    element: BarGroupedChart
};
